import { transport } from 'config/transport';

export function callApiExportAttendanceForm(params) {
    return transport.get(`/mamnon/export`, { params, responseType: 'blob' });
}
